module.exports = __webpack_public_path__ + "img/info.7ad8cdec.svg";